import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'components/elements'
import MapboxSearchBar from '../../../theme/mapboxSearchAutoComplete/mapboxSearchAutoComplete'
import { Subscribe } from 'unstated'
import SearchContainer from '../../../context/SearchContainer'
import CallSearch from '../../calls/runSearch.js'
import SearchResults from '../../layout/results/searchResults.js'
import './searchGooseEgg.css'
import DarkLoader from 'components/theme/assets/images/loaders/three-dots-dark.svg'
import {
  MAX_DISTANCE_FILTER_SHORT_NAME,
  MIN_DISTANCE_FILTER_SHORT_NAME,
  minDistanceDefault,
} from '../../filters/moreFiltersContainer/distanceFilterConfig'
import {
  LOCATION_SHORT_NAME,
  LATITUDE_SHORT_NAME,
  LONGITUDE_SHORT_NAME,
} from '../../filters/location/locationFiltersConfig'
import { IS_BIKE_FOR_SALE_FILTER_SHORT_NAME } from '../../filters/moreFiltersContainer/isBikeForSaleFilterConfig'

import MetaTags from '../../../elements/meta/metaTags.js'

class SearchGooseEgg extends React.Component {
  constructor(props) {
    super(props)
    const { filterValues } = this.props
    let filters = {}
    filters[LOCATION_SHORT_NAME] = filterValues[LOCATION_SHORT_NAME]
    filters[LATITUDE_SHORT_NAME] = filterValues[LATITUDE_SHORT_NAME]
    filters[LONGITUDE_SHORT_NAME] = filterValues[LONGITUDE_SHORT_NAME]
    filters[IS_BIKE_FOR_SALE_FILTER_SHORT_NAME] =
      filterValues[IS_BIKE_FOR_SALE_FILTER_SHORT_NAME]
    filters[MIN_DISTANCE_FILTER_SHORT_NAME] = minDistanceDefault
    filters[MAX_DISTANCE_FILTER_SHORT_NAME] = 250

    this.state = {
      filters,
    }
  }

  componentDidMount() { }

  componentWillUnmount() { }

  render() {
    const { filterValues, isMobile, mapVisible } = this.props
    const { filters } = this.state

    return (
      <div className="search-listings-body-wrap search-goose-egg columns">
        <MetaTags
          title="Sorry, we couldn't find any matching motorcycles."
          description="Sorry, no results found"
          url={'https://www.twistedroad.com/search'}
          setPrerenderStatusCode={true}
        />
        <div className="column">
          {!filterValues[LOCATION_SHORT_NAME] && (
            <div className="has-text-centered">
              <div className="columns has-text-centered is-centered">
                <div className="column is-8">
                  <h1 className="title is-size-3 has-text-weight-bold is-spaced">
                    Sorry, we couldn't find any matching motorcycles.
                  </h1>
                  <p className="subtitle is-size-5">Try a new search:</p>
                </div>
              </div>
              <Subscribe to={[SearchContainer]}>
                {(search) => {
                  return (
                    <div className="columns is-centered">
                      <div className="column is-5">
                        {isMobile ?
                          <div className='control is-relative has-icons-left'>
                            <input
                              placeholder='Search places...'
                              className='search-input input search-input-mobile search-input-focused'
                              onClick={(e) => {
                                e.preventDefault()
                                document.body.classList.add('mobile-search-focused')
                                document.getElementsByClassName('search-input input form-control mapbox-search-input header-search is-medium search-input-mobile react-mapbox-ac-input')[0].focus();
                              }}
                            />
                          </div> :
                          <MapboxSearchBar
                            selectSubmit={true}
                            isMobile={isMobile}
                            defaultAddress={''}
                            //defaultAddress={search.state.location}
                            searchObject={search}
                            grabAddressFromURL={false}
                            searchPlaceHolder={''}
                            focusSearch={true}
                            gooseEggSearch={true}
                            searchFrom="gooseEgg"
                          />
                        }
                      </div>
                    </div>
                  )
                }}
              </Subscribe>
            </div>
          )}
          {filterValues[LOCATION_SHORT_NAME] && (
            <>
              <div className="columns has-text-centered is-centered">
                <div className="column is-8">
                  <h1 className="title is-size-3 has-text-weight-extra-bold is-spaced search-error-message">
                    Sorry, we couldn't find any matching motorcycles in{' '}
                    {filterValues.location}
                  </h1>
                </div>
              </div>
              <CallSearch
                parseURLOnMount={false}
                searchFilters={filters}
                updateOnLocationURLChange={false}
                onSuccess={(data, meta) => {
                  this.props.onUpdateResults(data, meta)
                }}
                gooseEggSearch={true}
                searchDescription={
                  'GooseEgg Search Call from Search.js Component'
                }
                render={({
                  searchLoading,
                  runSearch,
                  searchError,
                  hasSearchData,
                  searchData,
                  initialURLParams,
                }) => {
                  let searchResults = searchData?.results
                  if (searchResults) {
                    if (searchResults.length >= 9) {
                      searchResults.length = 9
                    }
                  }
                  //limitedSearchData.length(9)

                  return (
                    <React.Fragment>
                      {searchLoading && (
                        <div className="has-text-centered mt-5 mb-6">
                          <img src={DarkLoader} alt="Search GooseEgg Loading" />
                        </div>
                      )}
                      {hasSearchData && !searchLoading && (
                        <>
                          <div className="has-text-centered">
                            <Button
                              type="button"
                              color="primary"
                              className="has-text-weight-extra-bold"
                              size="medium"
                              onClick={() => {
                                let filters = {}
                                filters[LOCATION_SHORT_NAME] =
                                  filterValues[LOCATION_SHORT_NAME]
                                filters[LATITUDE_SHORT_NAME] =
                                  filterValues[LATITUDE_SHORT_NAME]
                                filters[LONGITUDE_SHORT_NAME] =
                                  filterValues[LONGITUDE_SHORT_NAME]

                                this.props.onClearFilters(filters)
                              }}
                            >
                              Clear Filters & Retry
                            </Button>
                          </div>
                          {this.props.nextSearchUrl && (
                            <div className="has-text-centered mt-2">
                              <div className="has-text-weight-extra-bold search-goose-extra">
                                OR
                              </div>
                              <Link
                                className="try-searching-farther-away"
                                to={this.props.nextSearchUrl}
                              >
                                Try searching farther away
                              </Link>
                            </div>
                          )}

                          <div className="search-goose-egg-wrap">
                            <h2 className="title is-size-4 has-text-weight-extra-bold mb-5 has-text-centered">
                              Similar Motorcycles Nearby:
                            </h2>
                            <div className="columns">
                              <div className="column">
                                <SearchResults
                                  isMobile={isMobile}
                                  mapVisible={mapVisible}
                                  searchResults={searchResults}
                                  searchMeta={
                                    searchResults && searchResults.length ? {
                                      total_results: searchResults.length
                                    } : {}
                                  }
                                  currentTotalResults={searchResults.length}
                                //startDate={filterValues[startDateFilterShortName]}
                                //endDate={filterValues[endDateFilterShortName]}
                                //overRideLayout={3}
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      {!hasSearchData && !searchLoading && (
                        <div>
                          <Subscribe to={[SearchContainer]}>
                            {(search) => {
                              return (
                                <div className="columns is-centered">
                                  <div className="column is-5">
                                    {isMobile ?
                                      <div className='control is-relative has-icons-left'>
                                        <input
                                          placeholder='Search places...'
                                          className='search-input input search-input-mobile search-input-focused'
                                          onClick={(e) => {
                                            e.preventDefault()
                                            document.body.classList.add('mobile-search-focused')
                                            document.getElementsByClassName('search-input input form-control mapbox-search-input header-search is-medium search-input-mobile react-mapbox-ac-input')[0].focus();
                                          }}
                                        />
                                      </div> :
                                      <MapboxSearchBar
                                        selectSubmit={true}
                                        isMobile={isMobile}
                                        defaultAddress={''}
                                        //defaultAddress={search.state.location}
                                        searchObject={search}
                                        grabAddressFromURL={false}
                                        searchPlaceHolder={''}
                                        focusSearch={true}
                                        gooseEggSearch={true}
                                        searchFrom="gooseEgg"
                                      />
                                    }
                                    {/* <Searchbar
                                      selectSubmit={true}
                                      isMobile={isMobile}
                                      defaultAddress={''}
                                      //defaultAddress={search.state.location}
                                      searchObject={search}
                                      grabAddressFromURL={false}
                                      searchPlaceHolder={''}
                                      focusSearch={true}
                                    /> */}
                                  </div>
                                </div>
                              )
                            }}
                          </Subscribe>
                        </div>
                      )}
                    </React.Fragment>
                  )
                }}
              />
            </>
          )}

          <div className="need-more-help">
            <h2 className="title is-size-4 has-text-weight-extra-bold still-need-help">
              Still need help?
            </h2>
            <p className="subtitle is-size-6 mb-4">
              If you can't find the motorcycle you're looking for, maybe we can.
            </p>
            <Button
              color="primary"
              size="medium"
              className="has-text-weight-extra-bold"
            >
              Contact Us Now
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

export default SearchGooseEgg

SearchGooseEgg.defaultProps = {
  reloadPage: function () { },
  filterValues: {
    location: null,
    latitude: null,
    longitude: null,
  },
  onClearFilters: function () { },
  onUpdateResults: function () { },
  mapVisible: true,
}
